import script from "./MapRight.Layers.Item-Feature.vue?vue&type=script&setup=true&lang=js"
export * from "./MapRight.Layers.Item-Feature.vue?vue&type=script&setup=true&lang=js"

import "./MapRight.Layers.Item-Feature.vue?vue&type=style&index=0&id=50c6564e&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50c6564e"]])

export default __exports__